import React, {useEffect} from "react";
import Header from "../../components/Header";
import "./style.scss";
import { useTranslation } from "react-i18next";
import orderStore from "../../stores/order";
import { observer } from "mobx-react";
import { ReactComponent as IconPrinter } from "../../assets/icons/print.svg";
import { useNavigate } from "react-router";
import { useIdleTimer } from "react-idle-timer";
import config from "../../config/default.json";
import {addToLog, getAdditionalInformation} from "../../helpers/ApiHelper";
import { ReactComponent as IconInfo } from "../../assets/icons/info.svg";
import apiOpen from "../../api/open";

const ReceiptPage = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        addToLog(`Kitchen number #${orderStore.order.kitchenNumber}`);
        apiOpen.sendLogs(orderStore.order.id);
    }, []);

    const goToStart = () => {
        navigate("/");
        orderStore.resetOrder();
    }

    const printReceipt = async () => {
        await orderStore.printReceipt();
        goToStart();
    }

    const onIdle = () => {
        goToStart();
    }

    useIdleTimer({
        onIdle,
        timeout: config.idleStatus.pages.timeout
    });

    return <div className="ReceiptPage">
        <Header />
        <div className="container">
            <h2>{t("tankYou")}</h2>
            {getAdditionalInformation()
                ? <div className="additionalInformation">
                    <IconInfo />
                    {getAdditionalInformation()}
                </div>
                : null
            }
            <div className="receipt">
                <div className="text">
                    {t("yourOrder")}:
                </div>
                <div className="number">
                    #{orderStore.order.kitchenNumber}
                </div>
            </div>

            <div className="buttons">
                <div className="button" onClick={goToStart}>{t("noReceipt")}</div>
                <div className="button dark print" onClick={printReceipt}>
                    <IconPrinter />
                    {t("printReceipt")}
                </div>
            </div>
        </div>
    </div>
}

export default observer(ReceiptPage);
